export const PROMO_CODE_SET = 'PROMO_CODE_SET';
